package com.karawek.core.ui.designcatalog.sections

import androidx.compose.foundation.layout.*
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.karawek.core.ui.theme.CoreSpacing
import com.karawek.core.ui.theme.CoreTypography

@Composable
fun CatalogEmptyStates() {
    Column(verticalArrangement = Arrangement.spacedBy(CoreSpacing.md)) {

        Text("Empty States", style = CoreTypography.title)

        EmptyState(
            title = "No children yet",
            description = "Add a child to start tracking progress.",
        )

        EmptyState(
            title = "No messages",
            description = "Messages from therapists will appear here.",
        )
    }
}

@Composable
private fun EmptyState(
    title: String,
    description: String,
) {
    Column(
        modifier = Modifier.padding(CoreSpacing.lg),
        verticalArrangement = Arrangement.spacedBy(CoreSpacing.sm),
    ) {
        Text(title, style = CoreTypography.body)
        Text(description, style = CoreTypography.bodySecondary)
    }
}
